// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#notice[data-v-307823bd] {\r\n  position: absolute;\r\n  bottom: 12px;\r\n  left: 12px;\n}\r\n", ""]);
// Exports
module.exports = exports;
